import React, { Component } from 'react';
import Aux from '../../hoc/ReactAux';
import './Thanks.css';

class ThanksContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    const w = window;
    const d = document;
    const e = d.documentElement;
    const g = d.getElementsByTagName('body')[0];
    const x = w.innerWidth || e.clientWidth || g.clientWidth;
    const y = w.innerHeight || e.clientHeight || g.clientHeight;

    this.setState({ x, y });
  }

  render() {
    return (
      <Aux>
        <div>
          <img className="bg" alt="" src="./images/CorollaHeroMainFilter.jpg" />
          <div className="caption">
            <img className="captionIMGCar" alt="" src="./images/CorollaHeroCloseUp.jpg" />
            <div className="caption2">
              <img className="captionIMGOval" alt="" src="./images/RedOval.png" />
            </div>
            <div className="caption3">
              <img className="captionIMGThumb" alt="" src="./images/ThumbsUpTrans.png" />
            </div>
            <br />
            <div className="captionLower">
              {(this.props.gettingAuthToken || this.props.confirmingBooking) && (
                <span className="upperText">
                  <div>
                    Loading and Confirming request...
                    <br />
                    <br />
                  </div>
                </span>
              )}
              {(!this.props.gettingAuthToken || !this.props.confirmingBooking) && (
                <div>
                  <span className="upperText">
                    <div>
                      New Service Request - Rego
                      {this.props.rego}
                    </div>
                  </span>

                  <span className="middleText">
                    Thank you for using Toyota Online Service Booking.
                    <br />
                    Please contact guest to confirm or make changes to booking.
                  </span>
                  <br />
                  <br />
                  <span className="lowerText">
                    We use this to capture information that helps
                    <br />
                    improve our services.
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </Aux>
    );
  }
}

export default ThanksContainer;



// WEBPACK FOOTER //
// ./src/containers/Thanks/ThanksContainer.js